module.exports = __webpack_public_path__ + "static/img/role.8eab419.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/yjyx/role.png
// module id = X20v
// module chunks = 7